import { render } from "./CardLabel.vue?vue&type=template&id=de544964&lang=pug"
import script from "./CardLabel.vue?vue&type=script&lang=js"
export * from "./CardLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__